import React from "react";
import {
    ButtonRenderProps,
    Grid,
    GridColumn,
    GridRow,
    LabeledBadge,
    LabeledDate,
    LabeledText
} from "sprint-common-web";

import { LabeledTrailerInfoBadge } from "../../../../common/components/trailer-info/LabeledTrailerInfoBadge";
import {
    OrderResolutionDimensions,
    stringifyOrderResolutionDimensions
} from "../../../common/types/OrderResolutionDimensions";
import { resolveOrderRequestSourceBadgeColor } from "../../common/utils/resolveOrderRequestSourceBadgeColor";
import { OrderRequestSource } from "../../listing/OrderRequestListingItem";
import { OrderRequestSectionWrapper } from "../components/OrderRequestSectionWrapper";
import { OrderRequestDetailsStatus } from "./OrderRequestDetailsStatus";

interface OrderRequestDetailsSectionProps {
    minHeight: number;
}

export const OrderRequestDetailsSection = ({ minHeight }: OrderRequestDetailsSectionProps): JSX.Element => {
    const orderStatus: ButtonRenderProps = {
        render: OrderRequestDetailsStatus
    };

    return (
        <OrderRequestSectionWrapper
            header="Details"
            style={{ minHeight, flex: 1 }}
            buttons={[orderStatus]}
            testId="order-request-details-section"
        >
            {(orderRequest) => (
                <Grid>
                    <GridRow>
                        <GridColumn lg={6}>
                            <LabeledText
                                label="PO number"
                                testId="order-request-po-number"
                                value={orderRequest.pONumber}
                            />
                            <LabeledText
                                label="Content"
                                testId="order-request-content"
                                value={orderRequest.contentTitle}
                                maxLength={50}
                            />
                            <LabeledText
                                label="Airline"
                                testId="order-request-airline"
                                value={orderRequest.airline?.name}
                            />
                            {!!orderRequest.isTrailer && <LabeledTrailerInfoBadge />}
                            <LabeledDate
                                label="Start date"
                                testId="order-request-startDate"
                                value={new Date(orderRequest.startDate)}
                            />
                        </GridColumn>
                        <GridColumn lg={6}>
                            <LabeledText
                                label="System"
                                testId="order-request-system"
                                value={orderRequest.systemPlatform?.system?.name}
                            />
                            <LabeledText
                                label="Encode specification"
                                testId="order-request-encodeSpecification-name"
                                value={orderRequest.encodeSpecification?.name}
                            />
                            <LabeledText
                                label="Encode specification aspect ratio"
                                testId="order-request-encodeSpecification-aspectRatio"
                                value={orderRequest.encodeSpecification?.targetAspectRatio.name}
                            />
                            <LabeledText
                                label="Target resolution"
                                testId="order-request-targetResolution"
                                value={renderTargetResolution(orderRequest.targetResolution)}
                            />
                            <LabeledBadge
                                label="Source"
                                testId="order-request-source"
                                badgeSize={14}
                                value={OrderRequestSource[orderRequest.source]}
                                color={resolveOrderRequestSourceBadgeColor(orderRequest.source)}
                            />
                        </GridColumn>
                    </GridRow>
                </Grid>
            )}
        </OrderRequestSectionWrapper>
    );
};

const renderTargetResolution = (targetRes?: OrderResolutionDimensions) => {
    return targetRes ? stringifyOrderResolutionDimensions(targetRes) : "-";
};
